import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import TabelaFormaPagamento from './Components/TabelaFormaPagamento'
import Header from '../components/Header'

const mockPermissions = [
  { id: 1, formapagamento: 'Cartão de Crédito', ativo: true },
  { id: 2, formapagamento: 'Boleto Bancário', ativo: true },
  { id: 3, formapagamento: 'Pix', ativo: true },
  { id: 4, formapagamento: 'Transferência Bancária', ativo: false },
  { id: 5, formapagamento: 'Dinheiro', ativo: true },
  { id: 6, formapagamento: 'Cheque', ativo: false },
  { id: 7, formapagamento: 'Débito Automático', ativo: true },
  { id: 8, formapagamento: 'PayPal', ativo: true },
  { id: 9, formapagamento: 'Crédito em Conta', ativo: false },
  { id: 10, formapagamento: 'Crédito de Loja', ativo: true },
];


function FormaPagamento() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const headers = [
      { label: 'Selecionar', key: 'checkbox',isVisible: true },
      { label: 'ID', key: 'id', isVisible: true },
      { label: 'Forma de Pagamento', key: 'formapagamento', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Forma de Pagamento'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaFormaPagamento headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm} />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default FormaPagamento